import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-callc_upload_img",
  "use": "icon-callc_upload_img-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-callc_upload_img\"><clipPath id=\"icon-callc_upload_img_a\"><path d=\"m0 0h24v24h-24z\" /></clipPath><g clip-path=\"url(#icon-callc_upload_img_a)\" fill=\"#1a1a1a\"><path d=\"m21 21h-18c-1.103 0-2-.897-2-2v-12c0-1.103.897-2 2-2h3.382l.585-1.171c.25-.503.777-.829 1.342-.829h7.382c.564 0 1.091.326 1.342.831l.585 1.169h3.382c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2zm0-2v1zm-18-12v12h17.999l.001-12h-4.618l-1-2h-6.764l-1 2zm12.243-2.277c.001.001.001.001.001.002zm-6.486-.002-.001.002c.001-.001.001-.001.001-.002z\" /><path d=\"m12 17c-2.481 0-4.5-2.019-4.5-4.5 0-2.482 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 2.482-2.019 4.5-4.5 4.5zm0-7c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5c1.379 0 2.5-1.122 2.5-2.5s-1.121-2.5-2.5-2.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/callc_upload_img.svg
// module id = 9Xiq
// module chunks = 87